import React from 'react';
import {chapters} from '../data/content';

// Kapitel-Grid "Was dich im Buch erwartet"
function Chapters() {
  return (
    <section id="inhalt" className="mx-auto max-w-6xl px-4 py-16">
      <h2 className="text-3xl font-extrabold">Was dich im Buch erwartet</h2>
      <p className="mt-3 max-w-2xl text-gray-600">Sechs Kernkapitel führen dich von der Planung bis zur erfolgreichen Integration.</p>
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {chapters.map((c, i) => (
          <article key={c.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
            <span className="text-sm font-extrabold text-[#D52B1E]">Teil {i + 1}</span>
            <h3 className="mt-2 text-lg font-bold text-[#1E3A8A]">{c.title}</h3>
            <p className="mt-2 text-sm text-gray-600">{c.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Chapters;